import { ListItemNode, ListNode } from '@lexical/list';
import { InitialConfigType } from '@lexical/react/LexicalComposer';
import { EditorThemeClasses } from 'lexical';
import { onError } from '../utils';

const editorNamespace = 'CurewikiEditor';

const theme: EditorThemeClasses = {
  text: {
    underline: 'editorTextUnderline',
    italic: 'editorTextItalic',
    strikethrough: 'editorTextStrikeThrough',
    bold: 'editorTextBold',
    underlineStrikethrough: 'editorTextUnderlineStrikeThrough',
  },
  paragraph: 'editorParagraph',
  list: {
    ul: 'editorUnorderedList',
    ol: 'editorOrderedList',
    nested: {
      listitem: 'editorNestedListItem',
    },
    ulDepth: [
      'editorUnorderedListDepth1',
      'editorUnorderedListDepth2',
      'editorUnorderedListDepth3',
      'editorUnorderedListDepth4',
      'editorUnorderedListDepth5',
    ],
  },
};

export const initialConfig: InitialConfigType = {
  namespace: editorNamespace,
  onError,
  theme,
  nodes: [ListNode, ListItemNode],
};
